import React from 'react';
import { useNavigate } from 'react-router-dom';

const InvestmentCard = ({ product }) => {
  const navigate = useNavigate();

  const prefixedMainImage = product.mainImage && product.mainImage.startsWith('http')
    ? product.mainImage
    : `https://apiqms.shigjeta.com${product.mainImage}`;

  const handleInvestmentClick = () => {
    // Check for the 'id' property specifically
    if (product.id) {
      navigate(`/investment/${product.id}`);
    } else {
      console.error("InvestmentCard Error: Product is missing an 'id' property.", product);
    }
  };

  return (
    <div className="shop-product-card" onClick={handleInvestmentClick}>
      <img src={prefixedMainImage} alt={product.title} />
      <h3 className="product-title">{product.title}</h3>
      <p className="product-description">{product.description}</p>
    </div>
  );
};

export default InvestmentCard;